var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeeklyCoursePurchas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "purchase-tag-svgrepo-com",
    d: "M13.043,2.611A2.086,2.086,0,0,0,11.568,2H4.086A2.086,2.086,0,0,0,2,4.086v7.482a2.086,2.086,0,0,0,.611,1.475l8.346,8.346a2.086,2.086,0,0,0,2.95,0l7.482-7.482a2.086,2.086,0,0,0,0-2.95L13.043,2.611ZM7.216,9.3A2.087,2.087,0,1,1,9.3,7.216,2.087,2.087,0,0,1,7.216,9.3Z",
    transform: "translate(-2 -2)",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyCoursePurchas);
export default __webpack_public_path__ + "static/media/weekly-course-purchas.6230dc57bac39236d516394abfb01c98.svg";
export { ForwardRef as ReactComponent };